var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g2, _path10, _path11, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTopBgClosingWide = function SvgTopBgClosingWide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2208,
    height: 284,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.536 148h496.56a85.286 85.286 0 0 1 58.593 23.315l44.808 42.37A85.282 85.282 0 0 0 659.09 237h75.447",
    stroke: "url(#top-bg-closing-wide_svg__a)",
    strokeWidth: 25.17
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#top-bg-closing-wide_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M934.537 139h-30.761a85.284 85.284 0 0 0-65.79 31.017l-8.632 10.466a85.283 85.283 0 0 1-65.79 31.017h-75.031",
    stroke: "#95FFE4",
    strokeOpacity: 0.56,
    strokeWidth: 25.17
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M791.535 62h-67.967a85.283 85.283 0 0 1-57.447-22.25l-4.935-4.5A85.28 85.28 0 0 0 603.74 13H263",
    stroke: "url(#top-bg-closing-wide_svg__c)",
    strokeWidth: 25.17
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M791.328 62h74.195",
    stroke: "#14353B",
    strokeWidth: 25.17
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M934.537 139h91.543",
    stroke: "#ABE7ED",
    strokeWidth: 25.17
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M405.535 186.5h223.127a85.281 85.281 0 0 0 63.608-28.475l37.955-42.5a85.281 85.281 0 0 1 63.594-28.475L1094.54 87",
    stroke: "#327987",
    strokeWidth: 25.17
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M734.326 237h74.195",
    stroke: "#FFF7E0",
    strokeWidth: 25.17
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2207.46 109.5h-683.89a85.28 85.28 0 0 0-50.56 16.605l-93.07 68.518a85.28 85.28 0 0 1-50.56 16.605h-238.27",
    stroke: "url(#top-bg-closing-wide_svg__d)",
    strokeWidth: 25.17
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1836 22h-392.89a85.277 85.277 0 0 0-50.95 16.892l-72.11 53.716a85.268 85.268 0 0 1-50.94 16.892h-70.57",
    stroke: "url(#top-bg-closing-wide_svg__e)",
    strokeWidth: 25.17
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1178.33 109.5h74.19",
    stroke: "#327987",
    strokeWidth: 25.17
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#top-bg-closing-wide_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1399.04 134.719h-186.79a85.271 85.271 0 0 0-63.78 28.67l-17.26 19.441a85.271 85.271 0 0 1-63.78 28.67h-92.993",
    stroke: "#FFF1C0",
    strokeOpacity: 0.4,
    strokeWidth: 25.17
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1399.04 134.719h38.55",
    stroke: "#1E4750",
    strokeWidth: 25.17
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1600.4 237.056h74.19",
    stroke: "#ABE7ED",
    strokeWidth: 25.17
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#top-bg-closing-wide_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1560.54 271h-235.23a85.245 85.245 0 0 1-47.73-14.613l-45.56-30.774A85.277 85.277 0 0 0 1184.28 211H934.539",
    stroke: "#95FFE4",
    strokeOpacity: 0.56,
    strokeWidth: 25.17
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "top-bg-closing-wide_svg__a",
    x1: 0.536,
    y1: 192.5,
    x2: 298.001,
    y2: 192.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF9C3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF9C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "top-bg-closing-wide_svg__c",
    x1: 263,
    y1: 37.5,
    x2: 499,
    y2: 37.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#265761",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#265761"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "top-bg-closing-wide_svg__d",
    x1: 2207.46,
    y1: 160.364,
    x2: 1626.5,
    y2: 160.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABE7ED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABE7ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "top-bg-closing-wide_svg__e",
    x1: 1828,
    y1: 65.75,
    x2: 1493.5,
    y2: 65.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#265761",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#265761"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "top-bg-closing-wide_svg__b",
    x: 670.533,
    y: 108.415,
    width: 282.004,
    height: 133.67,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4234_17048"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_4234_17048",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "top-bg-closing-wide_svg__f",
    x: 936.438,
    y: 84.134,
    width: 500.602,
    height: 177.952,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 19
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4234_17048"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_4234_17048",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "top-bg-closing-wide_svg__g",
    x: 916.539,
    y: 180.415,
    width: 662,
    height: 121.17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4234_17048"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_4234_17048",
    result: "shape"
  })))));
};
export { SvgTopBgClosingWide as ReactComponent };
export default "data:image/svg+xml;base64,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";